<template>
  <div class="container">
    <h1>Batch Score CSV Upload</h1>
    <p>Upload a CSV file to score multiple loan applicants at once. Remember the column names in your uploaded file must be the exact model field names. An example CSV file is available
      <a href="/static/batch-example.csv">here</a> for reference.</p>
    <p>Please see the
      <router-link to="/about">About</router-link> page for the acceptable list of options for Company Type and NAICS code.</p>
    <div class="container mt-5">
      <form @submit.prevent="submit()" class="login-form">
        <div class="form-row">
          <div class="col-sm-4">
            <label class="control-label">Choose CSV File</label>
          </div>
          <div class="col-sm-8">
            <div class="form-group">
              <input class="form-control-file" type="file" @change="fileChange($event)">
            </div>
          </div>
        </div>
        <div v-if="errorMessage" class="form-row">
          <div class="col-sm-8 offset-sm-4">
            <div class="error-message">{{errorMessage}}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-sm-8 offset-sm-4">
            <button type="submit" class="btn btn-primary mt-3">Submit to LevelFi</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import DateFn from "date-fns";

import API from "@/services/api";
import CSVManager from "@/services/csvmanager";
import { AliasAndCalculate, FieldAliases } from "@/services/paramprocessor";


export default {
  data() {
    return {
      csvfile: null,
      errorMessage: undefined,
    };
  },
  mounted() {
    // Boot to login if not logged in
    if (!API.token) {
      this.$router.replace("/login");
    }
  },
  methods: {
    fileChange(event) {
      this.csvfile = event.target.files[0];
    },
    async submit() {
      this.errorMessage = undefined;
      let parsed;
      try {
        if (!this.csvfile.name.toLowerCase().endsWith(".csv")) {
          throw new Error("The upload must be a .csv file");
        }
        try {
          parsed = await CSVManager.ReadFile(this.csvfile);
        } catch (err) {
          throw new Error("Unable to parse CSV file");
        }
        const aliased = [];
        for (let i = 0; i < parsed.length; i++) {
          try {
            const alias = AliasAndCalculate(parsed[i]);
            aliased.push(alias);
          } catch (err) {
            throw new Error("Error in CSV row " + (i + 2) + ": " + err.message);
          }
        }

        /// Seperate out the contact fields from the model fields
        /// identify the contact Feilds
        // let contact_fields = FieldAliases.filter(function (item) {
        //     return item.contactField == true;
        // }).map(({ modelField }) => modelField);


        const result = await API.QueryModel({
          record_id: "record_id",
          data: aliased
        });
        if (
            result.status === 200 &&
            result.data &&
            result.data.body.predict.length
        ) {


          /// Calculate the Maxed approved Loan Amount
          let batch_calc_data = [];

          /// Need to add in the calculated values into a single object for the GenerateBatchCSV funtion to loop through
          for (let i = 0; i < result.data.body.predict.length; i++) {

              /// Get this alised Data
              let this_aliased = aliased[i];
              // Get this score
              let this_result = result.data.body.predict[i].score;

              /// Prepare payload
              let rec_params = {}
              rec_params.score = result.data.body.predict[i].score;
              rec_params.opp_fico_score = this_aliased.opp_fico_score;
              rec_params.opp_declared_household_income = this_aliased.opp_declared_household_income;
              rec_params.opp_declared_business_expenses = this_aliased.opp_declared_business_expenses;
              rec_params.opp_declared_business_total_income = this_aliased.opp_declared_business_total_income;
              /// this value is deleted after the alised step
              rec_params._personaldebt = this_aliased.opp_declared_household_income * this_aliased.opp_declared_personal_debt_income_ratio

              batch_calc_data.push(rec_params)
          }

          let calculated_fields = await API.getRecommendation({"data": batch_calc_data});
          calculated_fields = calculated_fields.data.body.data;

          let batch_csv_data = [];
          for (let i = 0; i < calculated_fields.length; i++) {
              console.log("in loop " + i)
              let this_calculated_fields = calculated_fields[i]
              // Get this score
              let this_result = result.data.body.predict[i].score

              // add to new object
              batch_csv_data.push({recordIDs: result.data.body.predict[i].recordIDs,
                  score: this_result,
                  risk_level: this_calculated_fields.risk_level,
                  ten_amountfico: this_calculated_fields.ten_amountfico,
                  ten_amount_cf: this_calculated_fields.ten_amount_cf,
                  ten_amount_levelfi: this_calculated_fields.ten_amount_levelfi,
                  rec_levelfi: this_calculated_fields.rec_levelfi
              });

          }

          const csv = CSVManager.GenerateBatchCSV(batch_csv_data);
          //const csv = CSVManager.GenerateBatchCSV(result.data.response.predict);
          const currenttime = DateFn.format(new Date(), "YYYY-MM-DD, HHmmss");
          API.DownloadFile("LevelFi Batch " + currenttime + ".csv", csv);
        } else {
          throw new Error("Bad response from LevelFi API");
        }
      } catch (err) {
        this.errorMessage = err.message;
      }
    }



  }
};
</script>

<style>
.form-row {
  margin-top: 20px;
}
.error-message {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/BatchUpload.vue